const whiteList = [
    '/login',
    '/register'
]

export default whiteList